export const getPolicy = () => {
  return fetch('/assets/policy.json').then((response) => response.json())
}
